import type { Language } from "@/contexts/LanguageContext";

export function localizeAuthMessage(
  language: Language,
  fallback: string,
  message?: string
) {
  if (!message) {
    return fallback;
  }

  if (language === "zh") {
    return message;
  }

  const map: Record<string, string> = {
    "请输入账号和密码": "Please enter your account and password.",
    "账号或密码错误": "Invalid account or password.",
    "账号不存在，请检查邮箱或用户名，或先注册新账号":
      "Account not found. Check your email or username, or create a new account first.",
    "账号已被停用，请联系管理员处理":
      "This account has been disabled. Please contact an administrator.",
    "密码错误，请重新输入，或使用忘记密码重置":
      "Incorrect password. Try again or use Forgot password to reset it.",
    "登录失败，请检查账号和密码后重试":
      "Sign in failed. Check your account and password, then try again.",
    "登录服务暂不可用，请稍后重试":
      "Login service is temporarily unavailable. Please try again later.",
    "未登录": "Not signed in.",
    "请填写邮箱、用户名和密码": "Please fill in your email, username, and password.",
    "密码长度不能少于 6 位": "Password must be at least 6 characters.",
    "用户名或邮箱已被注册": "Username or email is already registered.",
    "该邮箱已被注册，请直接登录或使用忘记密码找回账号":
      "This email is already registered. Sign in directly or use Forgot password to recover the account.",
    "该用户名已被注册，请更换用户名后再提交":
      "This username is already taken. Choose another username and submit again.",
    "账号信息已被使用，请调整邮箱或用户名后再提交":
      "This account information is already in use. Adjust the email or username and submit again.",
    "邮箱验证已失效，请重新验证":
      "Email verification has expired. Verify your email again.",
    "注册服务暂不可用，请稍后重试":
      "Registration is temporarily unavailable. Please try again later.",
    "请输入邮箱": "Please enter your email.",
    "如果该邮箱已注册，您将收到一封密码重置邮件。":
      "If the email is registered, you will receive a password reset email.",
    "密码重置服务暂不可用，请稍后重试":
      "Password reset service is temporarily unavailable. Please try again later.",
    "缺少重置令牌": "Missing reset token.",
    "无效或已过期的重置令牌": "The reset token is invalid or has expired.",
    "令牌校验失败，请稍后重试":
      "Token validation failed. Please try again later.",
    "缺少重置令牌或新密码": "Missing reset token or new password.",
    "您的密码已成功重置，请使用新密码登录。":
      "Your password has been reset. Please sign in with the new password.",
    "密码重置失败，请稍后重试":
      "Password reset failed. Please try again later.",
    "用户注册成功": "Account created successfully.",
    "Token 有效": "Token is valid.",
  };

  return map[message] || fallback;
}
